import { render } from "./ModuleAdd.vue?vue&type=template&id=71bc9f4c&scoped=true&ts=true"
import script from "./ModuleAdd.vue?vue&type=script&lang=ts"
export * from "./ModuleAdd.vue?vue&type=script&lang=ts"

import "./ModuleAdd.vue?vue&type=style&index=0&id=71bc9f4c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71bc9f4c"]])

export default __exports__